module.exports = "img/flags/AX.f8dce94.png";